import React, { useEffect, useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { Helmet } from 'react-helmet'
import { useAuth } from '@peracto/peracto-auth'

import * as ls from 'local-storage'

import { Heading, Group } from '@peracto/peracto-ui'

const OrdersConfirmationContainer = ({ children }) => {
    return (
        <div className="form-container">
            <Heading name="Order Confirmed">
                <div className="!grow !flex !items-center !justify-end">
                    <Link className="btn btn-outline-primary" to="/orders">
                        <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                        Back to Orders
                    </Link>
                </div>
            </Heading>
            {children}
        </div>
    )
}

const OrdersView = () => {
    const [redirect, setRedirect] = useState()
    const { user } = useAuth()

    const id = ls.get('convertedBasketId')

    useEffect(() => {
        if (!id) {
            setRedirect('/orders')
        }

        return () => {
            ls.remove('convertedBasketId')
            ls.remove(`${user?.profile?.id}_basket`)
        }
    }, [id])

    return (
        <OrdersConfirmationContainer>
            {redirect ? (
                <Redirect to={redirect} />
            ) : (
                <>
                    <Helmet>
                        <title>Order Confirmed | View | Peracto</title>
                    </Helmet>
                    {
                        <>
                            <Group
                                key="order-confirmed"
                                id="order-confirmed"
                                name="Order Confirmed"
                            >
                                <div className="!py-12 !text-center">
                                    <FontAwesomeIcon
                                        icon={faCheck}
                                        size="4x"
                                        className="!mb-2 !text-success"
                                    />

                                    <h4>Order Created</h4>

                                    <p>Order #{id} has been successfully created.</p>

                                    <p>
                                        <Link to={`/orders/${id}`}>View order</Link> or{' '}
                                        <Link to={`/orders/create`}>Create a new order</Link>
                                    </p>
                                </div>
                            </Group>
                        </>
                    }
                </>
            )}
        </OrdersConfirmationContainer>
    )
}

export default OrdersView
